export default __webpack_public_path__ + "static/media/StressesImg.6cf4df71.jpg";